<section class="grid-col-12 grid-max-width no-row-gap no-gutters">
  <h1
    data-testid="cms-teaser-title"
    class="nordic-blue-900-text col-1-12 font-heading-2 mr-clear-t ps-xsmall-t"
    *ngIf="content.teaserTitle as title"
  >
    {{ title }}
  </h1>
  <div
    *ngIf="content.detailText"
    [innerHTML]="content.detailText | resolveLinks | finSafe: 'html'"
    class="col-1-12 md-col-1-6 mr-clear pr-xsmall-t hero-content-text"
    data-testid="destination-search-hero-content"
  ></div>
</section>

<section *ngIf="picture || campaignText" class="mr-small-t">
  <header
    *ngIf="campaignText"
    class="campaign-content pr-xxsmall-y"
    [class.black-bg]="enableBlackTeaser"
    [class.heather-700-bg]="!enableBlackTeaser"
  >
    <div class="grid-col-12 grid-max-width no-row-gap campaign-ribbon">
      <div class="col-1-12 flex">
        <fcom-icon *ngIf="iconName" class="icon-medium" [name]="iconName"></fcom-icon>
        <div class="ms-xsmall-l bold-type" [innerHTML]="campaignText | resolveLinks | finSafe: 'html'"></div>
      </div>
    </div>
  </header>
  <section *ngIf="picture" class="campaign-content">
    <fin-content-image
      [imageData$]="picture | finToObservable"
      [aspectRatio$]="aspectRatio$"
      class="block image-height"
    >
    </fin-content-image>
  </section>
</section>
